import CustomOtpInput from "../../../../components/CustomOtpInput";
import {Box} from "@mui/material";
import {ButtonNextStep} from "../../../../components/buttons/ButtonNavigation";
import React from "react";
import {OpenDoorByDeviceModalApp} from "../Funtionality/OpenDoorByDeviceModalApp";
import CustomModal from "../../../../components/Modal/CustomModal";
import {
    AccessDeniedError,
    AccessGrantedSuccess,
    IconTitleEntryMethod,
    OpenDoorHeader
} from "../../../../components/buttons/IconButtons";
import CustomCard from "../../../../components/CustomCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 05 de 05 de 2026
 */

/**
 * Modal component used to validate OTP access
 * and remotely open a device door.
 *
 * This component handles:
 * - OTP input rendering.
 * - OTP validation flow.
 * - Access granted state.
 * - Access denied state.
 * - Loading and validation states.
 *
 * @component OpenDoorByDeviceModal
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.data - Device information object.
 * @param {number|string} props.data.id - Device identifier.
 *
 * @returns {JSX.Element} Open door modal component.
 */
const OpenDoorByDeviceModal = (props) => {

    const {data} = props
    const {
        handleVerify,
        isValidOtp,
        setIsValidOtp,
        loading,
        otp,
        setOtp,
        t,
        emptyFields,
        pass,
        setEmptyFields
    } = OpenDoorByDeviceModalApp(
        data
    );

    return (
        <>
            <CustomModal
                {...props}
                buttonConfirm="confirm"
                size={'md'}
                cancelButton={false}
                confirmButton={false}
                topLeftHeader={
                    <div className='d-flex align-items-center'>
                        <IconTitleEntryMethod />
                        <p className='fs-24px ibl-font-w-600  font-color-general-950 font-color-primary-600 ml-2'>
                            {t('open_door')}
                        </p>
                        <div className='vertical-separator h-auto' />
                    </div>
                }
            >
                <CustomCard classCard={"card-border-8px"} classContent={"p-0"}>
                    <OpenDoorHeader className={"w-100 h-100"}/>
                   <div className={"row p-12px"}>
                       {
                           isValidOtp === true ? (
                               pass ? (<div className={"row gap-3"}>
                                       <p className='col-12 d-flex justify-content-center fs-16px font-color-general-950 ibl-font-w-600'>
                                           {t('access_granted')}
                                       </p>

                                       <p className="col-12 d-flex justify-content-center fs-16px font-color-shades-950 ibl-font-w-400">
                                           {t("the_door_will_open_shortly")}
                                       </p>

                                       <AccessGrantedSuccess className={"col-12 w-100"} />
                                   </div>)
                                    : (<div className={"row gap-3"}>
                                       <p className='col-12 d-flex justify-content-center fs-16px font-color-general-950 ibl-font-w-600'>
                                           {t('access_denied')}
                                       </p>

                                       <p className="col-12 d-flex justify-content-center fs-16px font-color-shades-950 ibl-font-w-400">
                                           {t("you_dont_have_permission_to_enter")}
                                       </p>

                                       <AccessDeniedError className={"col-12 w-100"} />
                                   </div>)
                               )
                               : (<>
                                   <p className="fs-16px ibl-font-w-400 font-color-shades-950 d-flex justify-content-center mt-3">
                                       {t('open_door_description')}
                                   </p>

                                   <div className={'border-bottom-shades-300 my-3'} />

                                   <div className={"row my-5"}>
                                       <div className={"col-12 p-0 mt-0"}>

                                           <CustomOtpInput
                                               value={otp}
                                               onChange={(newValue) => {
                                                   const numericValue = newValue.replace(/\D/g, '');

                                                   setOtp(numericValue);
                                                   setIsValidOtp(null);
                                                   setEmptyFields(false);
                                               }}
                                               required={true}
                                               emptyFields={emptyFields}
                                               isValid={isValidOtp}
                                               inputLabel={"enter_code"}
                                               className={"fs-20px d-flex justify-content-center mt-3"}
                                           />

                                       </div>
                                   </div>

                                   <div className={"row"}>
                                       <Box className={"col-12 mt-1 mb-2 p-0"}>
                                           <ButtonNextStep
                                               id="btn_od_verify"
                                               text={"verify"}
                                               click={handleVerify}
                                               disabled={otp.length !== 6 || loading}
                                           />
                                       </Box>
                                   </div>
                               </>)
                       }
                   </div>
                </CustomCard>
            </CustomModal>
        </>
    )
}

export default OpenDoorByDeviceModal
